import { render, staticRenderFns } from "./editBox.vue?vue&type=template&id=4dffb6c9&scoped=true&"
import script from "./editBox.vue?vue&type=script&lang=js&"
export * from "./editBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dffb6c9",
  null
  
)

export default component.exports